module.exports = {
  "id": "rock",
  "title": "rock",
  "image": "provision/parts/rock/rock.png",
  "info": [
    {
      "text": "Add a rock to your project",
      "image": "provision/parts/rock/rock.png"
    }
  ],
  "exposedVariables": []
};